import { RefObject, useEffect, useRef } from 'react';
import PageSectionType from '@alltrails/amplitude/enums/PageSectionType';
import PageType from '@alltrails/amplitude/enums/PageType';
import logWebSectionViewed from '@alltrails/amplitude/events/logWebSectionViewed';
import useIsVisible from '@alltrails/core/hooks/useIsVisible';

const useLogWebSectionViewed = (
  ref: RefObject<HTMLElement | null>,
  sectionType?: PageSectionType,
  pageType?: PageType,
  options?: IntersectionObserverInit
) => {
  const wasViewedRef = useRef<boolean>(false);
  const isVisible = useIsVisible(ref, options);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    if (!isVisible || wasViewedRef.current || !pageType || !sectionType) {
      clearTimeout(timerRef.current);
      return;
    }

    if (isVisible && !wasViewedRef.current) {
      timerRef.current = setTimeout(() => {
        wasViewedRef.current = true;
        logWebSectionViewed({
          page_type: pageType,
          section_type: sectionType
        });
      }, 1000);
    }

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [isVisible]);
};

export default useLogWebSectionViewed;
